import type React from "react";

export default function TableCellBlank(): React.ReactNode {
  return <>{"—"}</>;
}
